import { render, staticRenderFns } from "./Users-list.vue?vue&type=template&id=40c2e530&"
import script from "./Users-list.vue?vue&type=script&lang=js&"
export * from "./Users-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports